const currencies = require('../currencies');
const ReferenceCurrenciesEnumList = require('./enumList');

const referenceCurrencies = ReferenceCurrenciesEnumList.reduce((memo, currency) => ({...memo, [currency]: currencies[currency] }), {});

module.exports = referenceCurrencies;